import { useEffect, useMemo, useState } from "react";
import * as THREE from "three";
import { loadHair, weights } from "../lib/bodyModel";

const KINDS = ["hair", "eyes", "mouth"];
const HAIR = { male: "#3a2618", female: "#6b4027" };

const blendKind = (arr, kind, age) => {
  const w = weights(age);
  const out = new Float32Array(arr[`${kind}_young`].length);
  ["child", "young", "old"].forEach((k) => {
    if (!w[k]) return;
    const a = arr[`${kind}_${k}`];
    for (let i = 0; i < out.length; i++) out[i] += w[k] * a[i];
  });
  const g = new THREE.BufferGeometry();
  g.setAttribute("position", new THREE.BufferAttribute(out, 3));
  g.setIndex(new THREE.BufferAttribute(arr[`${kind}_index`], 1));
  g.computeVertexNormals();
  return g;
};

// Vinyl-toy materials: sculpted hair block, glossy black eyes, tiny smile
const Part = ({ geo, kind, color, xray }) => (
  <mesh geometry={geo} raycast={() => null}>
    <meshPhysicalMaterial key={xray ? "x" : "o"} color={color} side={kind === "eyes" ? THREE.FrontSide : THREE.DoubleSide}
      roughness={kind === "eyes" ? 0.05 : kind === "hair" ? 0.62 : 0.6} clearcoat={kind === "eyes" ? 1 : 0.08}
      clearcoatRoughness={kind === "eyes" ? 0.02 : 0.4} envMapIntensity={kind === "eyes" ? 2 : 1}
      transparent={xray} opacity={xray ? 0.12 : 1} depthWrite={!xray} />
  </mesh>
);

export const Hair = ({ sex, age, xray }) => {
  const [data, setData] = useState(null);
  useEffect(() => { let on = true; loadHair(sex).then((d) => on && setData(d)); return () => { on = false; }; }, [sex]);
  const geos = useMemo(() => data && Object.fromEntries(KINDS.map((k) => [k, blendKind(data.arr, k, age)])), [data, age]);
  if (!geos) return null;
  const hair = age > 62 ? "#cfc9c0" : HAIR[sex];
  const colors = { hair, eyes: "#0b0b0d", mouth: "#5a2e26" };
  return (
    <group>
      {KINDS.map((k) => <Part key={k} geo={geos[k]} kind={k} color={colors[k]} xray={xray} />)}
    </group>
  );
};
